import React from "react";
import "./ScoreOverlay.css";
import { useTranslation } from "react-i18next";


function ScoreOverlay (props) {
    const { t } = useTranslation();

    let message;

    if (props.score > 4000) {
        message = `${t("message1")}`;
    }
    if(props.score <= 4000 && props.score > 2500) {
        message = `${t("message2")}`;
    }
    if(props.score <= 2500 && props.score > 1400) {
        message = `${t("message3")}`;
    }
    if (props.score === 1400) {
        message = `${t("message4")}`;
    }

    return (
        <React.Fragment>
            <div className="modal fade" id="scoreModal" tabIndex="-1" aria-labelledby="scoreModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content scoreModal">
                        <div className="modal-header header">
                            <h1 className="modal-title" id="scoreModalLabel">10 Task Planning Challenge</h1>
                            <button type="button" className="btn-close m-0" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body content">
                                <h2>{t("score")+": " + props.score}</h2>
                                <p>{t("time_needed")}</p>
                                {props.time}
                                <p>{message}</p>
                        </div>
                        <div className="modal-footer actions">
                            <button className="button" onClick={props.onClick} data-bs-dismiss="modal">{t("next")}</button>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ScoreOverlay;